export default __webpack_public_path__ + "static/media/search-player-banner-bg.493d5edf.png";